/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTION ///
import { Action } from "api/action_types/history";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/history";
/// TYPES ///
import { IHistory } from "api/types/history";
/// ACTIONS ///
import { historyAction } from "../api/history_action";

export const redo = () => {
  return (dispatch: Dispatch<Action>, getState: () => RootState) => {
    const redos: IHistory[] = getState().history.redo_history;
    const last: IHistory = redos[redos.length - 1];

    historyAction(
      last.redo_action,
      last.redo_data,
      last.redo_data2,
      dispatch
    );

    dispatch({
      type: ActionType.REDO
    });
  }
}
